import { useTranslation } from "react-i18next";
import { isSpanishLocale } from "../i18n";

/** Tutorials are Spanish-only video content. */
export function useTutorialsAvailable(): boolean {
  const { i18n } = useTranslation();
  return isSpanishLocale(i18n.resolvedLanguage ?? i18n.language);
}
